import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false


import "@/assets/css/bootstrap.min.css"
import "@/assets/css/common.css"
import "@/assets/css/animate.css"
import "@/assets/css/swiper.min.css"


new Vue({
  render: h => h(App),
}).$mount('#app')
